import { createAxeptioPlugin } from './plugins/AxeptioPlugin';
import { createCookiePolicyPlugin } from './plugins/CookiePolicyPlugin';
import { createNoopPlugin } from './plugins/NoopPlugin';

export const getConsentPlugin = (
  provider: string,
  config: {
    clientId: string;
    cookiesVersion: string;
    locale: string;
    tenantId: string;
  },
) => {
  switch (provider) {
    case 'axeptio':
      return createAxeptioPlugin(config);
    case 'cookie-policy':
      return createCookiePolicyPlugin();
    default:
      return createNoopPlugin();
  }
};
